import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const SetupLayout: React.FC = () => (
  <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
    <Outlet />
  </Box>
);

export default SetupLayout;
